import billingApiModule from '../billingApi.module';

class BillingGuestTokenApiService {
    constructor(__env, httpUtil, $q) {
        this.__env = __env;
        this.httpUtil = httpUtil;
        this.$q = $q;
    }

    getGuestToken(requestBody) {
        if (!requestBody) {
            return this.$q.reject();
        }

        return this.httpUtil.post(
            `${this.__env.billingApiUrl}/api/v1/guest-token`,
            requestBody
        );
    }
}

export default billingApiModule.service(
    'billingGuestTokenApiService',
    BillingGuestTokenApiService
);



// WEBPACK FOOTER //
// ./modules/billingApi/guestToken/billingGuestTokenApi.service.js